<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'almacen' }">{{
                $t("almacen")
              }}</router-link>
            </li>
            <li
              class="breadcrumb-item active"
              aria-current="page"
              style="text-transform: capitalize"
            >
              {{ $t("nueva") }}
              <template v-if="movimiento.tipo === 'S'">{{
                $t("salida")
              }}</template>
              <template v-else-if="movimiento.tipo === 'T'">{{
                $t("traspaso")
              }}</template>
              <template v-else>{{ $t("entrada") }}</template>
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6">
              <label for="referencia"
                ><strong>{{ $t("referencia") }} </strong></label
              >
              <input
                type="text"
                class="form-control"
                v-model="movimiento.referencia"
                placeholder="Introduzca referencia"
                id="referencia"
              />
            </div>

            <div class="col-md-6">
              <label><strong>Tipo</strong></label>
              <div class="form-group" id="tipo-movimiento">
                <el-radio v-model="movimiento.tipo" label="E"
                  >{{ $t("entrada") }}
                </el-radio>
                <el-radio v-model="movimiento.tipo" label="S"
                  >{{ $t("salida") }}
                </el-radio>
                <el-radio
                  v-if="listBusiness.length >= 2"
                  v-model="movimiento.tipo"
                  label="T"
                  >Traspaso
                </el-radio>
              </div>
              <el-checkbox v-model="productoCompleto">Trabajar con productos</el-checkbox>
              <i
                style="color:#1E22AA"
                v-tooltip.bottom="$t('textoAyudaProductoCompleto')"
                class="fa fa-sm fa-question-circle ml-1"
              ></i>
            </div>

            <template v-if="movimiento.tipo === 'T'">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="listBusiness"
                    ><strong>{{ $t("negocioDeDestino") }}</strong></label
                  >

                  <el-select
                    class="select-default"
                    size="large"
                    v-model="idBusinessOrigen"
                    filterable
                    :placeholder="this.$i18n.t('seleccionaNegocio')"
                  >
                    <el-option
                      v-for="business in listBusiness"
                      v-if="business.id !== idBusiness"
                      class="select-primary"
                      :value="business.id"
                      :label="business.establishmentName"
                      :key="business.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-if="!productoCompleto">
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <h5>{{ $t("materiasPrimas") }}</h5>
            </div>
            <div class="col-md-6">
              <el-select
                filterable
                class="select-default"
                style="width: 100%"
                remote
                v-model="idMateriaPrima"
                @change="selectMateriaPrima"
                reserve-keyword
                :placeholder="$t('buscarPorRefONombreDeLaMateriaPrima')"
                :remote-method="searchMateriaPrima"
              >
                <el-option
                  class="select-primary"
                  v-for="m in listMateriasPrimas"
                  :key="m.id"
                  :label="m.name"
                  :value="m.id"
                >
                </el-option>
              </el-select>
            </div>

            <div
              class="table-responsive col-md-12"
              style="margin-top: 20px;overflow: auto"
            >
              <table class="table table-bordered table-striped ">
                <thead class="thead-dark">
                  <tr>
                    <th>{{ $t("nombre") }}</th>
                    <th>{{ $t("unidades") }}</th>
                    <th>{{ $t("partes") }}</th>
                    <th>Tipo Escandallo</th>
                    <th>{{ $t('accion') }}</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="(materia, index) in movimiento.detalle" :class="{'row-temp-code': isTemporaryCode(materia.code)}">
                    
                     <td>
                       <i
                         v-if="isTemporaryCode(materia.code)"
                         v-tooltip.top-center="$t('materiaPrimaNoSincronizada')"
                         class="fas fa-exclamation-triangle text-warning"
                         style="cursor: help; margin-left: 5px"
                       ></i>
                       {{ materia.nombre }}
                     </td>
                    <td align="center">
                      <input
                        style="width: 80%"
                        type="number"
                        class="form-control"
                        v-model="materia.unidades"
                      />
                    </td>

                    <td align="center">
                      <input
                        style="width: 80%"
                        type="number"
                        class="form-control"
                        v-model="materia.partes"
                      />
                    </td>
                    <td align="center">
                      {{materia.tipoEscandallo}}
                    </td>
                    <td align="center">
                      <i
                        @click="removeSubproduct(index)"
                        v-tooltip.top-center="$t('eliminarMateriaPrima')"
                        class="fas fa-trash-alt text-danger"
                        style="cursor: pointer"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="col-md-5" style="margin-top: 60px">
              <div class="col-md-12" v-if="movimiento.detalle.length > 0">
                <div class="form-group">
                  <button v-once-click="saveMovimiento" class="btn btn-primary">
                    <i class="fa fa-check-square"></i>
                    {{ $t("guardar") }}
                  </button>

                  <router-link :to="{ name: 'historial-almacen' }">
                    <button class="btn btn-danger">
                      <i class="fa fa-window-close"></i>
                      {{ $t("cancelar") }}
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6">
              <div class="col-md-12">
                <h5>{{ $t("producto") }}</h5>
              </div>
              <div class="col-md-12">
                <el-select
                  filterable
                  class="select-default"
                  style="width: 100%"
                  remote
                  v-model="idProducto"
                  @change="selectProducto()"
                  reserve-keyword
                  :placeholder="$t('buscarPorRefONombreDelProducto')"
                  :remote-method="searchProducto"
                >
                  <el-option
                    class="select-primary"
                    v-for="m in listProductos"
                    :key="m.id"
                    :label="m.name"
                    :value="m.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="col-md-12">
                <h5>{{ $t("subproducto") }}</h5>
              </div>
              <div class="col-md-12">
                <el-select
                  filterable
                  class="select-default"
                  style="width: 100%"
                  remote
                  v-model="idMateriaPrima"
                  @change="selectMateriaPrima()"
                  reserve-keyword
                  :placeholder="$t('buscarPorRefONombreDeLaMateriaPrima')"
                  :remote-method="searchMateriaPrima"
                >
                  <el-option
                    class="select-primary"
                    v-for="m in listMateriasPrimas"
                    :key="m.id"
                    :label="m.name"
                    :value="m.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div
              class="table-responsive col-md-12"
              style="margin-top: 20px;overflow: auto"
            >
              <table class="table table-bordered table-striped ">
                <thead class="thead-dark">
                  <tr>
                    <th>{{ $t("nombre") }}</th>
                    <th>{{ $t("unidades") }}</th>
                    <th>{{ $t("partes") }}</th>
                    <th>{{ $t('escandallo') }}</th>
                    <th>{{ $t('accion') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(producto, index) in movimiento.detalleProducto">
                    <tr style="background-color: #FEF9E7" :key="producto.id + ' ' + producto.nombre">
                      <td width="50%"><span class="text-uppercase font-weight-bold">{{$t('producto')}}:</span> {{ producto.nombre}} </td>
                      <td width="15%" align="center">
                        <input
                          style="width: 80%"
                          type="number"
                          class="form-control"
                          v-model="producto.cantidad"
                        />
                      </td>
                      <td align="center" width="15%">
                        <!-- Partes -->-
                      </td>
                      <td align="center" width="15%">
                        <!-- Escandallo -->-
                      </td>
                      <td align="center">
                        <i
                          @click="removeProduct(index)"
                          v-tooltip.top-center="$t('eliminar') + ' ' + $t('producto')"
                          class="fas fa-trash-alt text-danger"
                          style="cursor: pointer"
                        ></i>
                      </td>
                    </tr>
                    <tr v-for="(materia, indexMateria) in producto.subproductos" :key="materia+' '+index" :class="{'row-temp-code': isTemporaryCode(materia.code)}">
                       <td>
                         <span class="text-uppercase font-weight-bold">  · {{$t('materiaPrima')}}:</span>
                         <i
                           v-if="isTemporaryCode(materia.code)"
                           v-tooltip.top-center="$t('materiaPrimaNoSincronizada')"
                           class="fas fa-exclamation-triangle text-warning"
                           style="cursor: help; margin-left: 5px"
                         ></i>
                         {{ materia.nombre }}
                       </td>
                      <td align="center">
                        <!-- Unidades -->
                        {{ producto.cantidad }} x
                      </td>
                      <td align="center">
                        {{materia.partes}}
                      </td>
                      <td align="center">
                        {{materia.escandallo}} <span v-if="materia.tipoEscandallo">({{materia.tipoEscandallo}})</span>
                      </td>
                      <td align="center">
                        <i
                          @click="removeProductSubproduct(index, indexMateria)"
                          v-tooltip.top-center="$t('eliminarMateriaPrima')"
                          class="fas fa-trash-alt text-danger"
                          style="cursor: pointer"
                        ></i>
                      </td>
                    </tr>
                  </template>
                  <template v-for="(materia, index) in movimiento.detalle">
                    <tr :key="index" style="background-color: #FEF9E7" :class="{'row-temp-code': isTemporaryCode(materia.code)}"><!--#e7fef1-->
                       <td>
                         <span class="text-uppercase font-weight-bold">{{$t('materiaPrima')}}:</span>
                         <i
                           v-if="isTemporaryCode(materia.code)"
                           v-tooltip.top-center="$t('materiaPrimaNoSincronizada')"
                           class="fas fa-exclamation-triangle text-warning"
                           style="cursor: help; margin-left: 5px"
                         ></i>
                         {{ materia.nombre }}
                       </td>
                      <td align="center">
                        <input
                          style="width: 80%"
                          type="number"
                          class="form-control"
                          v-model="materia.unidades"
                        />
                      </td>

                      <td align="center">
                        <input
                          style="width: 80%"
                          type="number"
                          class="form-control"
                          v-model="materia.partes"
                        />
                      </td>
                      <td align="center">
                        {{materia.tipoEscandallo}}
                      </td>
                      <td align="center">
                        <i
                          @click="removeSubproduct(index)"
                          v-tooltip.top-center="$t('eliminarMateriaPrima')"
                          class="fas fa-trash-alt text-danger"
                          style="cursor: pointer"
                        ></i>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div class="col-md-5" style="margin-top: 60px" v-if="!productoCompleto">
              <div class="col-md-12" v-if="movimiento.detalle.length > 0">
                <div class="form-group">
                  <button v-once-click="saveMovimiento" class="btn btn-primary">
                    <i class="fa fa-check-square"></i>
                    {{ $t("guardar") }}
                  </button>

                  <router-link :to="{ name: 'historial-almacen' }">
                    <button class="btn btn-danger">
                      <i class="fa fa-window-close"></i>
                      {{ $t("cancelar") }}
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
            <div v-else class="col-md-5" style="margin-top: 60px">
              <div class="col-md-12" v-if="movimiento.detalleProducto.length > 0">
                <div class="form-group">
                  <button v-once-click="saveMovimientoProducto" class="btn btn-primary">
                    <i class="fa fa-check-square"></i>
                    {{ $t("guardar") }}
                  </button>

                  <router-link :to="{ name: 'historial-almacen' }">
                    <button class="btn btn-danger">
                      <i class="fa fa-window-close"></i>
                      {{ $t("cancelar") }}
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CabeceraInformes from "../../../pages/Dashboard/Informes/CabeceraInformes.vue";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  Switch,
  Radio,
  Loading,
} from "element-ui";

import swal from "sweetalert2";

export default {
  props: ["idProducto"],
  name: "GestionAlmacen",
  components: {
    CabeceraInformes,
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Radio.name]: Radio,
  },
  data() {
    return {
      movimiento: {
        referencia: "",
        tipo: "E",
        detalle: [],
        detalleProducto: [],
      },
      idBusiness: this.$route.params.idBusiness,
      idMovimiento: this.$route.params.idMovimiento,
      //MATERIAS PRIMAS REMOTAS
      listMateriasPrimas: [],
      listProductos: [],
      idMateriaPrima: "",
      //LISTBUSINESS
      listBusiness: [],
      idBusinessOrigen: 0,
      idBusinessPartida: 0,
      productoCompleto: false,
      sinVerificar: false,
      modalNotSynchronizedShown: false,
    };
  },
  created() {

    if (this.idMovimiento) {
      this.getMovimiento();
    }

    this.$store.dispatch("setNameRoute", "Movimiento Almacén");

    this.getBusiness();
    this.checkSinVerificar();
  },
  watch: {
    $route(to, from) {
      if (to.params.idMovimiento) {
        this.idMovimiento = to.params.idMovimiento;
        this.getMovimiento();
      }
    }
  },
  computed: {
    hasTempCodes() {
      // Revisar materias primas sueltas
      for (let m of this.movimiento.detalle) {
        if (this.isTemporaryCode(m.code)) return true;
      }
      // Revisar subproductos dentro de productos
      for (let p of this.movimiento.detalleProducto) {
        for (let s of p.subproductos) {
          if (this.isTemporaryCode(s.code)) return true;
        }
      }
      return false;
    }
  },
  methods: {
    isTemporaryCode(code) {
      if (!code || !/^\d{10}$/.test(String(code))) return false;
      const ts = Number(code);
      return ts >= 1577836800 && ts <= 4102444800;
    },
    searchMateriaPrima(query) {

      this.listProductos = [];

      if (query !== "") {
        const controller = "searchSubproductsByGestionGasto/" + query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
          .then(function(response) {
            if (response.data.response) {
              vm.listMateriasPrimas = response.data.result.listSubproduct;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    searchProducto(query) {

      this.listMateriasPrimas = [];

      if (query !== "") {
        const controller = "searchProductsByGestionGasto/" + query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "products/" + controller, config)
          .then(function(response) {
            if (response.data.response) {
              vm.listProductos = response.data.result.listProducts;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    selectMateriaPrima() {
      let vm = this;
      this.listMateriasPrimas.forEach(function(x) {
        if (x.id === vm.idMateriaPrima) {
          let MateriaPrima = {
            id: x.id,
            nombre: x.name,
            unidades: 1,
            idProducto: 0,
            partes: 0,
            code: x.code,
            escandallo: x.escandallo,
            tipoEscandallo: x.type,
          };

          vm.movimiento.detalle.push(MateriaPrima);

          // if (vm.isTemporaryCode(x.code) && !vm.modalNotSynchronizedShown) {
          //   swal({
          //     title: vm.$t("atencion"),
          //     text: vm.$t("listaPresentaMateriasPrimasNoSincronizadas"),
          //     confirmButtonClass: "btn btn-info btn-fill",
          //     type: "warning",
          //   });
          //   vm.modalNotSynchronizedShown = true;
          // }
        }
      });

      vm.idMateriaPrima = "";
    },
    selectProducto() {
      
      let vm = this;
      
      let alreadyArray = vm.movimiento.detalleProducto.filter(p => p.id === vm.idProducto);

      if (alreadyArray.length > 0) {
        let indice = vm.movimiento.detalleProducto.indexOf(alreadyArray[0]);
        vm.movimiento.detalleProducto[indice].cantidad = parseInt(vm.movimiento.detalleProducto[indice].cantidad) + 1;
      } else {
        this.listProductos.forEach(function(product) {

          if (product.id === vm.idProducto) {

              let producto = {
                  id: product.id,
                  nombre: product.name,
                  cantidad: 1,
                  subproductos: [],
              }

              let hasTemp = false;
              product.subproducts.forEach(function (subproduct) {

                let MateriaPrima = {
                  id: subproduct.id,
                  nombre: subproduct.name,
                  idProducto: product.id,
                  partes: subproduct.partes,
                  escandallo: subproduct.escandallo,
                  tipoEscandallo: subproduct.tipoEscandallo,
                  code: subproduct.code,
                };

                producto.subproductos.push(MateriaPrima);

                if (vm.isTemporaryCode(subproduct.code)) {
                  hasTemp = true;
                }
              });

              vm.movimiento.detalleProducto.push(producto);

              // if (hasTemp && !vm.modalNotSynchronizedShown) {
              //   swal({
              //     title: vm.$t("atencion"),
              //     text: vm.$t("listaPresentaMateriasPrimasNoSincronizadas"),
              //     confirmButtonClass: "btn btn-info btn-fill",
              //     type: "warning",
              //   });
              //   vm.modalNotSynchronizedShown = true;
              // }
          }

        });
      }
      vm.idProducto = "";
    },

    checkDatos() {
      let check = true;

      if (this.movimiento.referencia === "") {
        check = false;

        swal({
          title: this.$t("atencion"),
          text: this.$t("referenciaNecesaria"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else if (this.movimiento.detalle.length === 0 && this.movimiento.detalleProducto.length === 0) {
        check = false;

        swal({
          title: this.$t("atencion"),
          text: this.$t(
            "elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos"
          ),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      }

      return check;
    },
    checkSinVerificar() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 81,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.sinVerificar = true;
          } else {
            vm.sinVerificar = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    
    },
    saveMovimiento() {
      if (this.checkDatos()) {
        this.loading = Loading.service({ text: "Cargando..." });
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idBusiness: this.idBusiness,
          movimiento: this.movimiento,
          idBusinessOrigen: this.idBusinessOrigen,
          idBusinessPartida: this.idBusiness,
          sinVerificar: this.sinVerificar
        };

        let vm = this;
        let controller = "saveMovimiento";
        if (this.idMovimiento) {
          controller = "editMovimiento";
        }
        this.axios
          .post(
            this.$store.getters.apiUrl + "almacen/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              let movimiento = "";

              if (vm.movimiento.tipo === "S") {
                movimiento = vm.$t("salida");
              } else if (vm.movimiento.tipo === "T") {
                movimiento = vm.$t("traspaso");
              } else {
                movimiento = vm.$t("entrada");
              }

              let notify = "";
              vm.$notify({
                message:
                  movimiento +
                  " " +
                  vm.$t("realizado") +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
              vm.$router.push({
                name: "historial-almacen",
                params: { idBusiness: vm.idBusiness },
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          }).finally((_) => {
            vm.loading.close();
          });
      }
    },
    saveMovimientoProducto() {
      if (this.checkDatos()) {
        this.loading = Loading.service({ text: "Cargando..." });
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idBusiness: this.idBusiness,
          movimiento: this.movimiento,
          idBusinessOrigen: this.idBusinessOrigen,
          idBusinessPartida: this.idBusiness,
          productoCompleto: this.productoCompleto,
          sinVerificar: this.sinVerificar
        };

        let vm = this;
        let controller = "saveMovimientoProducto";
        if (this.idMovimiento) {
          controller = "editMovimientoProducto";
        }
        this.axios
          .post(
            this.$store.getters.apiUrl + "almacen/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              let movimiento = "";

              if (vm.movimiento.tipo === "S") {
                movimiento = vm.$t("salida");
              } else if (vm.movimiento.tipo === "T") {
                movimiento = vm.$t("traspaso");
              } else {
                movimiento = vm.$t("entrada");
              }

              let notify = "";
              vm.$notify({
                message:
                  movimiento +
                  " " +
                  vm.$t("realizado") +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
              vm.$router.push({
                name: "historial-almacen",
                params: { idBusiness: vm.idBusiness },
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          }).finally((_) => {
            vm.loading.close();
          });
      }
    },
    removeSubproduct(index) {
      this.movimiento.detalle.splice(index, 1);
    },
    removeProduct(index) {
      this.movimiento.detalleProducto.splice(index, 1);
    },
    removeProductSubproduct(index, indexMateria) {
      if (this.movimiento.detalleProducto[index].subproductos.length > 0) this.movimiento.detalleProducto[index].subproductos.splice(indexMateria, 1);
      //this.movimiento.detalleProducto[index].subproductos.splice(indexMateria, 1);
      if (this.movimiento.detalleProducto[index].subproductos.length <= 0) this.movimiento.detalleProducto.splice(index, 1);
      
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusiness = response.data.result;

          if (response.data.result.length > 2) {
            vm.idBusinessOrigen =
              response.data.result[0].id !== vm.idBusiness
                ? response.data.result[0].id
                : response.data.result[1].id;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getMovimiento() {
      var config = {
        params: {
          idMovimiento: this.idMovimiento,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "almacen/getMovimientoById", config)
        .then(function(response) {
          vm.movimiento = response.data.result;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
}
.row-temp-code {
  background-color: #fff9c4 !important;
}
/* .row-temp-code td {
  color: #721c24;
}
.row-temp-code .fa-trash-alt {
  color: #dc3545 !important;
} */
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/GestionAlmacen/EntradaAlmacen.vue